const CALENDLY_URL = 'https://paystack.com/buy/private-clarity-call-sdonrr';

const includes = [
  'Structured sessions led by Mandie',
  'Curated group of serious women',
  'Shared prompts and somatic practices',
  'Community between sessions',
];

export default function Offer2Section() {
  return (
    <section className="bg-[#6B1E3B] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-12">
          {/* Left — Image */}
          <div className="lg:col-span-2 flex items-center justify-center order-2 lg:order-1">
            <div className="w-full max-w-[320px] mx-auto lg:max-w-none aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Small%20intimate%20circle%20of%20Black%20women%20sitting%20together%20in%20a%20warmly%20lit%20room%20during%20golden%20hour%2C%20soft%20natural%20light%20falling%20on%20their%20faces%2C%20women%20engaged%20in%20deep%20authentic%20conversation%2C%20cream%20and%20beige%20interior%20with%20woven%20textures%2C%20community%20healing%20gathering%2C%20editorial%20photography%20with%20warm%20golden%20tones%20and%20soft%20shadows%2C%20genuine%20connection%20and%20vulnerability%2C%20high%20detail%20emotional%20depth&width=600&height=750&seq=offer2-group-2026-v2&orientation=portrait"
                alt="Group healing circle of African women in community"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right — Text */}
          <div className="lg:col-span-3 order-1 lg:order-2">
            {/* Eyebrow */}
            <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4">
              Heal in community
            </p>

            {/* Headline */}
            <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] mb-6 leading-tight">
              There is medicine in being witnessed by other women.
            </h2>

            {/* Body */}
            <p className="font-body text-sm md:text-base text-[#E8E8E8] leading-relaxed mb-8">
              In Mandie's group containers, women come together to do real structured healing work, and discover that the thing they were most afraid to say out loud is the exact thing another woman needed to hear.
            </p>

            {/* Includes */}
            <ul className="space-y-3 mb-8">
              {includes.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-[#C9A84C] mt-2 flex-shrink-0" />
                  <span className="font-body text-sm text-[#E8E8E8]">{item}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 w-full sm:w-auto"
            >
  Book a Clarity Call
</a>
<p className="text-xs text-[#4A4A4A] mt-2">
  <a href="https://paystack.com/buy/private-clarity-call-sdonrr" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#D4006A]">Book a Private Clarity Call</a>
</p>
          </div>
        </div>
      </div>
    </section>
  );
}